import React, { Component } from 'react';
import styles from './CreateEntity.module.css';
import ImportForm from '../../components/ImportForm';
import JsonForm from '../../components/JsonForm';
import Divider from '../../components/Divider';
import { connect } from 'react-redux';
import { createModel, getModel, saveModel } from '../../modules/models';
import { getTags } from '../../modules/tags';
import { createScene, saveScene, getScene } from '../../modules/scenes';
import PropTypes from 'prop-types';

class CreateEntity extends Component {
  state = {
    formData: {},
    metadata: {},
    schema: [
      { key: 'sku', label: 'SKU', required: false },
      { key: 'friendlyName', label: 'Item Description', required: true },
      { key: 'tags', label: 'Tags', multi: true, select: true },
      {
        key: 'state',
        label: 'State',
        select: true,
        options: [
          { label: 'Active', value: 'Active' },
          { label: 'Discontinued', value: 'Discontinued' },
          { label: 'Canceled', value: 'Canceled' },
        ],
      },
      { key: 'thumbnail', label: 'Thumbnail' },
      { key: 'description', label: 'Description' },
      { key: 'helpText', label: 'Help Text' },
    ],
  };

  static contextTypes = {
    router: PropTypes.object,
  };

  navTo = (id, cat) => {
    const { router } = this.context;
    const url = `/${cat}${id ? `/${id}` : ''}`;
    router.history.push(url);
  };

  async componentDidMount() {
    const { router } = this.context;
    const { id } = router.route.match.params;
    if (id) {
      const { catogary, getModel, getScene } = this.props;
      if (catogary === 'models') {
        const model = await getModel(id);
        this.setState({ formData: model, metadata: model.metadata });
      } else if (catogary === 'scenes') {
        const scene = await getScene(id);
        this.setState({ formData: scene, metadata: scene.metadata });
      }
    }
  }

  createOrUpdateEntity = () => {
    const { router } = this.context;
    const { formData, schema, metadata } = this.state;
    const {
      catogary,
      createModel,
      createScene,

      type,
      saveModel,

      saveScene,
    } = this.props;
    for (let i in schema) {
      if (schema[i].required && !formData[schema[i].key]) {
        this.setState({ error: `${schema[i].label} is required ` });
        return;
      }
    }
    this.setState({ error: null });
    formData.metadata = metadata;
    if (type === 'new') {
      if (catogary === 'models') {
        createModel(formData).then(e => {
          router.history.push('/');
        });
      } else if (catogary === 'scenes') {
        createScene(formData).then(e => {
          router.history.push('/');
        });
      }
    } else if (type === 'edit') {
      const { id } = router.route.match.params;
      if (catogary === 'models') {
        saveModel(id, formData).then(e => router.history.push(`/models/${id}`));
      } else if (catogary === 'scenes') {
        saveScene(id, formData).then(e => router.history.push(`/scenes/${id}`));
      }
    }
  };

  onChange = (key, value) => {
    const { formData } = this.state;
    formData[key] = value;
    this.setState({ formData });
  };

  onMetadataChange = data => {
    const metadata = data.reduce((acc, v) => {
      acc[v.label] = v.value;
      return acc;
    }, {});
    this.setState({ metadata });
  };

  render() {
    const { catogary, type, tags } = this.props;
    const { formData, schema, error, metadata } = this.state;
    return (
      <div className={styles.newModel}>
        <div className={styles.header}>
          {type === 'new' ? 'New' : 'Edit'}{' '}
          {catogary[0].toUpperCase() + catogary.slice(1, -1)} Information
        </div>
        <Divider />
        <ImportForm
          schema={schema}
          catogary={catogary}
          formData={formData}
          onChange={this.onChange}
          tags={tags}
        />
        <JsonForm
          type={type}
          onChange={this.onMetadataChange}
          metadata={metadata}
        />
        {error && <div className={styles.errorText}>{error} </div>}
        <button
          className={styles.saveButton}
          onClick={this.createOrUpdateEntity}
        >
          {type === 'new' ? 'Create' : 'Update'}
        </button>
      </div>
    );
  }
}

const createEntityPage = (catogary, type) => {
  return connect(
    state => ({
      catogary,
      type,
      tags: getTags(state),
    }),
    {
      createModel,
      createScene,
      getModel,
      saveModel,
      saveScene,
      getScene,
    }
  )(CreateEntity);
};

export default createEntityPage;



// WEBPACK FOOTER //
// ./src/containers/CreateEntity/index.js